export const CLEARTRIP = 'CLEARTRIP'
export const FLYIN = 'FLYIN'
export const MOBILE = 'MOBILE'
export const DESKTOP = 'DESKTOP'
